module.exports = __webpack_public_path__ + "img/auto-topup-icon.278bb625.svg";